import React from 'react';

import { useIntl } from 'react-intl';

import { CARD_ALIAS_TRANSLATION_ID } from 'utils/gift-card/constants';
import { relativeRoutes } from 'utils/routing';

import { PrepaidTransferBalanceLink } from './styled';

function PrepaidTransferBalance() {
  const { formatMessage } = useIntl();
  const cardAlias = formatMessage({ id: CARD_ALIAS_TRANSLATION_ID });
  return (
    <PrepaidTransferBalanceLink
      data-testid="prepaid-transfer-balance"
      to={relativeRoutes.transferGiftCard}
    >
      {formatMessage({ id: 'transferBalanceFromAnotherCard' }, { cardAlias })}
    </PrepaidTransferBalanceLink>
  );
}
export default PrepaidTransferBalance;
